import React from "react";
import clsx from "clsx";

import {makeStyles} from "@material-ui/core";

import Tooltip from "../Tooltip";


const useStyles = makeStyles(() => ({
  truncateText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }
}))

const TruncatedText = ({text, deps = [], className}) => {
  const classes = useStyles();
  const ref = React.useRef(null);

  const [isTruncated, setIsTruncated] = React.useState(false);

  React.useEffect(() => {
    const el = ref.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [text, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <Tooltip title={text} disableHoverListener={!isTruncated} width={600}>
      <div ref={ref} className={clsx(classes.truncateText, className)}>
        {text}
      </div>
    </Tooltip>
  )
};

export default TruncatedText;